import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import { useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const markerIcon = new L.Icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41]
});

function LocationMarker({ position, setPosition }) {

  useMapEvents({
    click(e) {
      const { lat, lng } = e.latlng;
      setPosition({ lat, lng });
    }
  });

  return position ? (
    <Marker position={position} icon={markerIcon} />
  ) : null;
}

export default function MapPicker({ onChange }) {

  const [position, setPosition] = useState(null);

  const handleSetPosition = (pos) => {
    setPosition(pos);
    onChange(pos);
  };

  return (
    <div className="h-64 rounded-xl overflow-hidden border">

      <MapContainer
        center={[-17.8830, -63.3165]}
        zoom={13}
        style={{ height: "100%", width: "100%" }}
      >

        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <LocationMarker
          position={position}
          setPosition={handleSetPosition}
        />

      </MapContainer>

    </div>
  );
}